export const QuestionnaireOptionsArr = [
  "Nutrition guidance and support",
  "Motivation",
  "Exercise technique",
  "Education",
  "Constant feedback on stats"
];